/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}


export function isBase64(str) {
    if (str ==='' || str.trim() ===''){ return false; }
    try {
      return btoa(atob(str)) == str;
    } catch (err) {
      return false;
    }
}


export function objectValueAllEmpty(object) {
  var isEmpty = true;
  Object.keys(object).forEach(function (x) {
    if (object[x] != null && object[x] != "" && object[x] != undefined) {
      isEmpty = false;
    }
  });
  return isEmpty;
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validatezipCole(str) {
  const reg = /^[0-9]{6}$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validRegNumber(str) {
  const reg = /^\+?[1-9][0-9]*$/
  return reg.test(str)
}

//判断是否为照片还是文件
export function matchFileSuffixType (fileName) {
  // 后缀获取
  var suffix = ''
  // 获取类型结果
  var result = ''
  try {
    var flieArr = fileName.split('.')
    suffix = flieArr[flieArr.length - 1]
  } catch (err) {
    suffix = ''
  }
  // fileName无后缀返回 false
  if (!suffix) {
    result = false
    return result
  }
  // 图片格式
  var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
  // 进行图片匹配
  result = imglist.some(function (item) {
    return item == suffix
  })
  if (result) {
    result = 'image'
    return result
  }
  // 匹配txt
  var txtlist = ['txt']
  result = txtlist.some(function (item) {
    return item == suffix
  })
  if (result) {
    result = 'txt'
    return result
  }
  // 匹配 excel
  var excelist = ['xls', 'xlsx']
  result = excelist.some(function (item) {
    return item == suffix
  })
  if (result) {
    result = 'excel'
    return result
  }
  // 匹配 word
  var wordlist = ['doc', 'docx']
  result = wordlist.some(function (item) {
    return item == suffix
  })
  if (result) {
    result = 'word'
    return result
  }
  // 匹配 pdf
  var pdflist = ['pdf']
  result = pdflist.some(function (item) {
    return item == suffix
  })
  if (result) {
    result = 'pdf'
    return result
  }
  // 匹配 ppt
  var pptlist = ['ppt']
  result = pptlist.some(function (item) {
    return item == suffix
  })
  if (result) {
    result = 'ppt'
    return result
  }
  // 匹配 视频
  var videolist = ['mp4', 'm2v', 'mkv']
  result = videolist.some(function (item) {
    return item == suffix
  })
  if (result) {
    result = 'video'
    return result
  }
  // 匹配 音频
  var radiolist = ['mp3', 'wav', 'wmv']
  result = radiolist.some(function (item) {
    return item == suffix
  })
  if (result) {
    result = 'radio'
    return result
  }
  // 其他 文件类型
  result = 'other'
  return result
}

export function validatePassword2(rule, password, callback) {
  //定义验证规则，由于字符串数字和字母的顺序可能不同。
//也有可能字母和数字中间还包含了其他字符。故将验证规则分开定义。
  // var regNumber = /\d+/; //验证0-9的任意数字最少出现1次。
  // var regString = /[a-zA-Z]+/; //验证大小写26个字母任意字母最少出现1次。
  // var regSpecial = /#|%|\*|-|_|!|@|$|&/; // 特殊字符必须是这些最少出现1次

  var contentPattern = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&*()])[\da-zA-Z!@#$%^&*()]{8,20}$/;
  if(!contentPattern.test(password)){
      // result.message = "最少包含1个大写字母、1个小写字母、1个数字、一个指定的特殊字符、长度10到20" ;
      // return "最少包含1个大写字母、1个小写字母、1个数字、一个指定的特殊字符、长度10到20";
      callback(new Error("最少包含1个大写字母或1个小写字母、1个数字、一个指定的特殊字符、长度8到20"));
  }else{
    callback()
  }
};


export const validateMobile = (rule, value, callback) => {
  if (
    !/^1[0-9]{10}$/.test(value)
  ) {
    callback(new Error("手机号格式错误"));
  } else {
    callback();
  }
};

// 邮箱校验
export const validateemail = (rule, value, callback) => {
  if (!/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(value))
  {
    callback(new Error("邮箱格式错误"));
  }
  else {
    callback();
  }
};



export function validatelimitNumInfo(rule, info, callback){
  let contentPattern=/^(.|\n){1,200}$/;
  if(!contentPattern.test(info)){
    callback(new Error("最多输入200字"));
}else{
  callback()
}
}




// 验证时间前后
export function validateTimeCompare(value, validEndDate) {
  let endDate = new Date(validEndDate);
  let endGetTime = endDate.getTime();
  let startDate = new Date(value);
  let startGetTime = startDate.getTime();
  if (startGetTime != 0 && endGetTime != 0 && startGetTime > endGetTime) {
    return true;
  }
  return false;
}













// WEBPACK FOOTER //
// ./src/plugins/validsUtils.js